import { bricklinkUpdateDialogStateSchema } from '@state/_shared/bricklinkUpdateDialogStateSchema';

/**
 * Inventory Audit page state.
 *
 * The audit page's own data (header, finding pages, job) is local to its action
 * handler, but the BrickLink XML dialog reads and writes its open flag and
 * session through AppState under the page name it was handed — so this page
 * needs the slice registered even though nothing else here is global.
 */
export const inventoryAuditPageStateSchema = {
    bricklinkUpdateDialog: bricklinkUpdateDialogStateSchema
};

export default inventoryAuditPageStateSchema;
